// extracted by mini-css-extract-plugin
export var deleteIcon = "_oj-5";
export var deleteOption = "_oj-3";
export var divider = "_oj-2";
export var downloadIcon = "_oj-4";
export var drawer = "_oj-0";
export var drawerFooter = "_oj-6";
export var drawerOpen = "_oj-1";
export var highlighted = "_oj-7";
export var lighterHighlight = "_oj-8";